import React from 'react';
import '../style/Teaching.scss';
// react Bootstrap
import { Container } from 'react-bootstrap';
// component
import Header from '../components/public/Header';
import SchoolTimeLine from '../components/public/SchoolTimeLine';
import CarouselComponent from '../components/public/CarouselComponent';
//React Redux
import { connect } from 'react-redux';

function School1({ lang }) {
  const totalNumber = 5;
  const date = ['2009', '2010', '2011', '2012', '2013', '2014'];

  const title = [
    '2009 school photo',
    '2010 school photo',
    '2011 school photo',
    '2012 school photo',
    '2013 school photo',
    '2014 first school visit',
    // '2015 school photo',
  ];

  const chineseContent = [
    [
      {
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20091.JPG?alt=media&token=8207895d-cb9c-4f90-ba0b-267a202bc4c8',
        width: 4,
        height: 3,
      },
      {
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20092.JPG?alt=media&token=3db63aa3-b917-4028-ba2d-5542f6b6da6a          ',
        width: 4,
        height: 3,
      },
      {
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20094.JPG?alt=media&token=b0743d47-1f81-475c-b5e5-2f6cebe10d4c',
        width: 4,
        height: 3,
      },
      {
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20095.JPG?alt=media&token=8e27f224-ef73-453f-9943-0b18ac62c6e5',
        width: 4,
        height: 3,
      },
    ],
    [
      {
        // no: 1 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
        width: 5,
        height: 3,
      },
      {
        // no: 2 2010,
        src:
          ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20102.JPG?alt=media&token=b4d26050-fae0-441e-99ee-7538c486eda6',
        width: 5,
        height: 3,
      },
      {
        // no: 3 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20103.JPG?alt=media&token=8b257872-cdb0-4b9c-b112-814bf0b99a7d',
        width: 5,
        height: 3,
      },
      {
        // no: 4 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20104.JPG?alt=media&token=6c1dd016-caa0-4ebe-8daf-4d4805027d40',
        width: 5,
        height: 3,
      },
      {
        // no: 5 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20105.JPG?alt=media&token=bbb10ac9-ff90-41ad-8972-d0c5c5f754f5',
        width: 5,
        height: 3,
      },
      {
        // no: 6 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20106.JPG?alt=media&token=84e13dc3-0888-48c8-9fe3-2d282232b6d6',
        width: 5,
        height: 3,
      },
      {
        // no: 7 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20107.JPG?alt=media&token=04cec2e2-f869-4459-8728-d06227cfcfa9',
        width: 5,
        height: 3,
      },
      {
        // no: 8 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20108.JPG?alt=media&token=9b1b2368-9a8b-40c8-bae8-fae076eb5d90',
        width: 5,
        height: 3,
      },
      {
        // no: 9 2010,
        src:
          ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20109.JPG?alt=media&token=0ea3dd2f-0530-4071-a139-42c96c17f9ce',
        width: 5,
        height: 3,
      },
      {
        // no: 10 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201010.JPG?alt=media&token=16683ca5-95d6-425b-a6f8-5fe3958877c8',
        width: 5,
        height: 3,
      },
      {
        // no: 11 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201011.JPG?alt=media&token=546e2909-11b9-4427-aa0a-a964b4d71b7e',
        width: 5,
        height: 3,
      },
      {
        // no: 12 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201012.JPG?alt=media&token=8ee069e6-5ac6-4bd5-899d-13b290d87455',
        width: 5,
        height: 3,
      },
      {
        // no: 13 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201013.JPG?alt=media&token=fcf3be50-d871-4b92-a056-a20cdc1548a7',
        width: 5,
        height: 3,
      },
      {
        // no: 14 2010,
        src:
          ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201014.JPG?alt=media&token=fa65bd95-9263-4fb9-8ded-2445c1b2e449',
        width: 5,
        height: 3,
      },
      {
        // no: 15 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201015.JPG?alt=media&token=361ca9f7-e0d2-42b6-818a-afb2aa34e0e4',
        width: 5,
        height: 3,
      },
      {
        // no: 16 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201016.JPG?alt=media&token=ea80544c-6e9e-4977-a9f3-fb2e9c2ed7b0',
        width: 5,
        height: 3,
      },
      {
        // no: 17 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201017.JPG?alt=media&token=575a50f6-a678-4958-8fcd-4015b94312bd',
        width: 5,
        height: 3,
      },
      {
        // no: 18 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201018.JPG?alt=media&token=f2413cfc-0e78-444c-b7e6-6a433e1e1244',
        width: 5,
        height: 3,
      },
      {
        // no: 19 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201019.JPG?alt=media&token=66cda15e-3d60-4315-9653-087e528924a3',
        width: 5,
        height: 3,
      },
      {
        // no: 20 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201020.JPG?alt=media&token=6c4a52a7-cebe-4571-82a0-27125bcb400d',
        width: 5,
        height: 3,
      },
      {
        // no: 21 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201021.JPG?alt=media&token=864f63d6-bf00-4b83-8118-633c2932ee68',
        width: 5,
        height: 3,
      },
      {
        // no: 22 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201022.JPG?alt=media&token=8eca5962-ccd0-4114-bb6f-cdef3c4df9ad',
        width: 5,
        height: 3,
      },
      {
        // no: 23 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201023.JPG?alt=media&token=2ae850e5-3375-4cd2-bde2-3b49a5c105c4',
        width: 5,
        height: 3,
      },
      {
        // no: 24 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201024.JPG?alt=media&token=2dfa7514-b754-4206-80bb-1fc381096168',
        width: 5,
        height: 3,
      },
      {
        // no: 25 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201025.JPG?alt=media&token=01beafc3-b85d-4e6c-b677-4bf5c8fd7332',
        width: 5,
        height: 3,
      },
      {
        // no: 26 2010,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201026.JPG?alt=media&token=8b7e3eb8-c6fe-4f9e-8b93-c8e540762d07',
        width: 5,
        height: 3,
      },
    ],
    [
      {
        // no: 2 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20112.JPG?alt=media&token=802f8a09-2dd6-4fe4-8b70-fd2c9043466b',
        width: 5,
        height: 3,
      },
      {
        // no: 3 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20113.JPG?alt=media&token=eebd89b7-3c81-4660-94af-a43dfc2b9ee1',
        width: 5,
        height: 3,
      },
      {
        // no: 4 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20114.JPG?alt=media&token=8255d8b8-8cd8-4f3c-b823-0827b9faec25',
        width: 5,
        height: 3,
      },
      {
        // no: 5 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20115.JPG?alt=media&token=b1a72d7a-201b-48d2-b5ab-233dbb42932b',
        width: 5,
        height: 3,
      },
      {
        // no: 6 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20116.JPG?alt=media&token=0d7ca1a5-871d-4da1-9673-52892c3e8324',
        width: 5,
        height: 3,
      },
      {
        // no: 7 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20117.JPG?alt=media&token=e10a8f52-43e0-49c5-b9e8-f3eed72d94d5',
        width: 5,
        height: 3,
      },
      {
        // no: 8 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20118.JPG?alt=media&token=fcb288dd-4b41-45d2-b9d7-ae716ec26bad',
        width: 5,
        height: 3,
      },
      {
        // no: 9 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20119.JPG?alt=media&token=ed876858-adb1-4644-8a06-45b0264f6d59',
        width: 5,
        height: 3,
      },
      {
        // no: 10 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201110.JPG?alt=media&token=b34722c9-e3c5-44d0-959e-2cea1d53229e',
        width: 5,
        height: 3,
      },
      {
        // no: 11 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201111.JPG?alt=media&token=fed696ed-25f3-4806-b4d8-10ed2f8e5112',
        width: 5,
        height: 3,
      },
      {
        // no: 12 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201112.JPG?alt=media&token=39fdfd83-5ae1-4ea8-a83f-4ff7f30ea54e',
        width: 5,
        height: 3,
      },
      {
        // no: 13 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201113.JPG?alt=media&token=80032ec7-276d-4a72-bc8b-0331522a437a',
        width: 5,
        height: 3,
      },
      {
        // no: 14 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201114.JPG?alt=media&token=4de89b34-592c-40ae-952a-0149d0ba06f6          ',
        width: 5,
        height: 3,
      },
      {
        // no: 15 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201115.JPG?alt=media&token=5e731441-ed96-45b5-8dff-0ab107ceb031',
        width: 5,
        height: 3,
      },
      {
        // no: 16 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201116.JPG?alt=media&token=d055ff42-e9df-489a-ac18-cbc50ba04c4c',
        width: 5,
        height: 3,
      },
      {
        // no: 17 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201117.JPG?alt=media&token=f9f0f157-1a21-455b-8d65-d833c51c2a0b',
        width: 5,
        height: 3,
      },
      {
        // no: 18 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201118.JPG?alt=media&token=f3d9abff-fd5d-4bce-9a4f-7a08c98166dc',
        width: 5,
        height: 3,
      },
      {
        // no: 19 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201119.JPG?alt=media&token=00b34f54-ff81-42b5-b0e6-b43b405ba355',
        width: 5,
        height: 3,
      },
      {
        // no: 20 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201120.JPG?alt=media&token=9332b506-21f5-4fb9-82b8-109afb398534',
        width: 5,
        height: 3,
      },
      {
        // no: 21 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201121.JPG?alt=media&token=6c3f1a39-4c9f-4164-9f0d-f7bac8664888',
        width: 5,
        height: 3,
      },
      {
        // no: 22 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201122.JPG?alt=media&token=9772a2c5-11ff-4705-80da-aa827dd47768',
        width: 5,
        height: 3,
      },
      {
        // no: 23 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201123.JPG?alt=media&token=31096731-fce7-41d0-9f1c-cc51e0e05d8a',
        width: 5,
        height: 3,
      },
      {
        // no: 24 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201124.JPG?alt=media&token=2a8b93cc-9262-46e7-94ef-c25bcceed8eb',
        width: 5,
        height: 3,
      },
      {
        // no: 25 2011,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201125.JPG?alt=media&token=e20414c6-69a6-47a4-9a3f-8fdf08a49092',
        width: 5,
        height: 3,
      },
    ],
    [
      {
        // no: 1,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
        width: 5,
        height: 3,
      },
      {
        // no: 2,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20122.JPG?alt=media&token=58297f6e-ff54-43a2-a237-a7efd21e42b9',
        width: 5,
        height: 3,
      },
      {
        // no: 3,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20123.JPG?alt=media&token=0fe41057-3ec9-4ab5-9e3e-9f8b3090d103',
        width: 5,
        height: 3,
      },
      {
        // no: 4,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20124.JPG?alt=media&token=87d5c59d-4577-4b35-a65d-66bc8415e8cf',
        width: 5,
        height: 3,
      },
      {
        // no: 5,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20125.JPG?alt=media&token=f5d0db4b-f2ee-45b4-8408-30505c9df3d0          ',
        width: 5,
        height: 3,
      },
      {
        // no: 6,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20126.JPG?alt=media&token=2437fe1b-f123-45b4-9121-fc5e9192666c',
        width: 5,
        height: 3,
      },
      {
        // no: 7,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20127.JPG?alt=media&token=3224eb51-7376-4d2f-8783-81e155c7246e',
        width: 5,
        height: 3,
      },
      {
        // no: 8,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20128.JPG?alt=media&token=e50bac2b-1ac4-456f-8aa7-0b4850a6cbb2',
        width: 5,
        height: 3,
      },
      {
        // no: 9,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20129.JPG?alt=media&token=6e00260e-50fc-4342-bda7-44398993ca91',
        width: 5,
        height: 3,
      },
      {
        // no: 10,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201210.JPG?alt=media&token=bf7561fd-20fa-4d0b-bc12-8c4f42fe2fc3',
        width: 5,
        height: 3,
      },
      {
        // no: 11,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201211.JPG?alt=media&token=2ea5f6a7-5817-4716-8613-eac08d017fd7',
        width: 5,
        height: 3,
      },
      {
        // no: 12,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201212.JPG?alt=media&token=44a49ba0-27c5-416c-98bd-5433c7a81353',
        width: 5,
        height: 3,
      },
      {
        // no: 13,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201213.JPG?alt=media&token=dd947b38-7847-45ad-8a5e-6f780c94cc05          ',
        width: 5,
        height: 3,
      },
      {
        // no: 14,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201214.JPG?alt=media&token=81056c8e-732b-4606-97b4-b0c03cc0644c',
        width: 3,
        height: 5,
      },
      {
        // no: 15,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201215.JPG?alt=media&token=f4b9ac48-f408-4f11-8c1c-edc131d66c2b          ',
        width: 3,
        height: 5,
      },
      {
        // no: 16,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201216.JPG?alt=media&token=04e4bb22-f08d-494a-8bdd-5d138c82eee4',
        width: 5,
        height: 3,
      },
      {
        // no: 17,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201217.JPG?alt=media&token=b53c81cc-401d-426a-bcba-9c7b84eff9cb',
        width: 5,
        height: 3,
      },
      {
        // no: 18,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201218.JPG?alt=media&token=4d1483ca-6272-44ae-9e53-02824a1cb631',
        width: 5,
        height: 3,
      },
      {
        // no: 19,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201219.JPG?alt=media&token=7521de71-af3a-475b-b991-8b4d255e7a06          ',
        width: 5,
        height: 3,
      },
      {
        // no: 20,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201220.JPG?alt=media&token=30b724e6-cac1-474c-99f4-52da7bfe1156',
        width: 5,
        height: 3,
      },
      {
        // no: 21,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201221.JPG?alt=media&token=e9ab214a-5937-4a35-8689-f41e84364ae9',
        width: 5,
        height: 3,
      },
      {
        // no: 22,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201222.JPG?alt=media&token=3e0ea9ec-793c-4916-ada2-08f0acfb0334',
        width: 5,
        height: 3,
      },
      {
        // no: 23,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201223.JPG?alt=media&token=817401c4-d0fe-4b45-9ff4-62cb01a81431',
        width: 5,
        height: 3,
      },
      {
        // no: 24,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201224.JPG?alt=media&token=571ce59c-0165-4cbd-8f7b-e208244af631',
        width: 5,
        height: 3,
      },
      {
        // no: 25,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201225.JPG?alt=media&token=b22681b2-c57d-49a1-8a13-b26b569b4bd7',
        width: 5,
        height: 3,
      },
      {
        // no: 26,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201226.JPG?alt=media&token=a514be5b-142a-4344-b7f0-aff5ccf04956',
        width: 5,
        height: 3,
      },
      {
        // no: 27,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201227.JPG?alt=media&token=608d7e9f-71ee-4e59-9d7e-defd62f1a999',
        width: 5,
        height: 3,
      },
      {
        // no: 28,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201228.JPG?alt=media&token=329402b5-ef76-42ae-bfad-ccae05fcdd30',
        width: 5,
        height: 3,
      },
      {
        // no: 29,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201229.JPG?alt=media&token=46549947-4ff8-4dc0-bc11-a2bce17090fe          ',
        width: 5,
        height: 3,
      },
      {
        // no: 30,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201230.JPG?alt=media&token=573e815e-ec2a-47ff-9baa-e45f6d3a82ce',
        width: 5,
        height: 3,
      },
      {
        // no: 31,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201231.JPG?alt=media&token=6450fe2a-34bc-4b0d-8093-a55e5a287085',
        width: 5,
        height: 3,
      },
      {
        // no: 32,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201232.JPG?alt=media&token=abfe06fc-bdc4-46a6-bbb2-93da89083bbb',
        width: 5,
        height: 3,
      },
      {
        // no: 33,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201233.JPG?alt=media&token=3a722c19-1918-4565-815f-d5d6f22e1b46',
        width: 5,
        height: 3,
      },
      {
        // no: 34,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201234.JPG?alt=media&token=9b5de75d-f9c4-4ed4-ad24-0221357cf304',
        width: 5,
        height: 3,
      },
      {
        // no: 35,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201235.jpg?alt=media&token=01507455-ea3c-4cc3-9dcd-3e3d6b2062be',
        width: 5,
        height: 3,
      },
      {
        // no: 36,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201236.jpg?alt=media&token=14bcc695-94fb-4a10-aa0c-c16cf434ddb6',
        width: 5,
        height: 3,
      },
      {
        // no: 37,
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201237.jpg?alt=media&token=147e0367-0629-4320-86e6-d1866441b816',
        width: 5,
        height: 3,
      },
    ],
    [
      {
        // number 1
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20131.JPG?alt=media&token=56ada541-70fb-4067-a1f0-ff569f77b0e7',
        width: 5,
        height: 3,
      },
      {
        // number 2
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20132.JPG?alt=media&token=3c50485f-180a-49d3-9495-d7f60d8ee3d0',
        width: 5,
        height: 3,
      },
      {
        // number 3
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20133.JPG?alt=media&token=ac514fa3-4fdd-4268-8b56-48f3ef9847a5',
        width: 5,
        height: 3,
      },
      {
        // number 4
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20134.JPG?alt=media&token=03b318c5-541a-4045-abe3-e7305ad747df',
        width: 5,
        height: 3,
      },
      {
        // number 5
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20135.JPG?alt=media&token=354bcd71-e771-421e-9371-74ac5e9fa17b',
        width: 5,
        height: 3,
      },
      {
        // number 6
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20136.JPG?alt=media&token=5757b37a-5620-4520-ae9d-e2d4daa4855e',
        width: 5,
        height: 3,
      },
      {
        // number 7
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20137.JPG?alt=media&token=5601ff18-bc9a-42a6-95eb-a0140c135a7a',
        width: 5,
        height: 3,
      },
      {
        // number 8
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20138.JPG?alt=media&token=98d8c5f5-4129-4219-b60b-459b9a8ee5da',
        width: 5,
        height: 3,
      },
      {
        // number 9
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20139.JPG?alt=media&token=95e19ca1-809a-4c52-bc93-7bfbff088339          ',
        width: 5,
        height: 3,
      },
      {
        // number 10
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201310.JPG?alt=media&token=27dcf8df-70ac-4b9e-85a3-097df7b56cb7',
        width: 5,
        height: 3,
      },
      {
        // number 11
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201311.JPG?alt=media&token=3c229fec-488e-4391-9bf9-0d4315884ec4',
        width: 5,
        height: 3,
      },
      {
        // number 12
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201312.JPG?alt=media&token=c431a9e6-9d14-4954-89f8-f386f5fed511',
        width: 5,
        height: 3,
      },
      {
        // number 13
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201313.JPG?alt=media&token=918bfb61-ed07-48f7-a90d-b5da096dddbd',
        width: 5,
        height: 3,
      },
      {
        // number 14
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201314.JPG?alt=media&token=61b947c4-2514-4065-993c-61df19b6dda0',
        width: 5,
        height: 3,
      },
      {
        // number 15
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201315.JPG?alt=media&token=624483ee-27ec-4550-ae85-60ec0e246ba7',
        width: 5,
        height: 3,
      },
      {
        // number 16
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201316.JPG?alt=media&token=37e50e9b-db6d-4946-bbd4-bcc400d98b15',
        width: 5,
        height: 3,
      },
      {
        // number 17
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201317.JPG?alt=media&token=d7af734a-48d3-4b03-b0a4-c6f0026cb28b',
        width: 5,
        height: 3,
      },
      {
        // number 18
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201318.JPG?alt=media&token=32379565-476a-4301-8f65-712dd37b539e',
        width: 5,
        height: 3,
      },
      {
        // number 19
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool201319.JPG?alt=media&token=3f7fa214-cb95-4372-aa42-c46fdc3e96b3',
        width: 5,
        height: 3,
      },
    ],
    [
      {
        // number 1
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool2014Visit1.JPG?alt=media&token=b6cdfdae-7f4d-4437-8660-db19ade906c6',
        width: 5,
        height: 3,
      },
      {
        // number 2
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool2014Visit2.JPG?alt=media&token=fb6f1a31-1d85-43d6-a444-12dd69b4f38d',
        width: 5,
        height: 3,
      },
      {
        // number 3
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool2014Visit3.JPG?alt=media&token=b82e89c2-289e-4e9b-b601-fe34235526ce',
        width: 5,
        height: 3,
      },
      {
        // number 4
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool2014Visit4.JPG?alt=media&token=021021ab-93b1-47e5-8e8b-6fec026b41fe',
        width: 5,
        height: 3,
      },
      {
        // number 5
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool2014Visit5.JPG?alt=media&token=f0df375c-0e3d-468a-ab7f-bbec2e12f4d2',
        width: 5,
        height: 3,
      },
      {
        // number 6
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool2014Visit6.JPG?alt=media&token=cce47291-1798-4ef2-9fef-b8214c1cf166',
        width: 5,
        height: 3,
      },
      {
        // number 7
        src:
          'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool2014Visit7.JPG?alt=media&token=97dad1e2-8726-4fc4-bcb0-1e4ac4c8d69c          ',
        width: 5,
        height: 3,
      },
    ],
    // [
    //   {
    //     // no: 1 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 2 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 3 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 4 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 5 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 6 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 7 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 8 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 9 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 10 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 11 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 12 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 13 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 14 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 15 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 16 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 17 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 18 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 19 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 20 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 21 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 22 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 23 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 24 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 25 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 26 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 27 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 28 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 29 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   },
    //   {
    //     // no: 30 2015,
    //     src:
    //       'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fschool20121.JPG?alt=media&token=caad2201-6132-46b5-86e5-622bdf60058b          ',
    //     width: 5,
    //     height: 3,
    //   }
    // ],
  ];

  const carouselContent = [
    {
      // number 3
      image:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fteaching3.jpg?alt=media&token=822b532e-44ce-49df-af00-6d852898553d',
      caption: 'first caption',
    },
    {
      // number 4
      image:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fteaching4.jpg?alt=media&token=53343ddc-4a34-4e24-93a9-62a611873c9f',
      caption: 'first caption',
    },
    {
      // number 5
      image:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Ftibet1.jpg?alt=media&token=876b9fd5-1945-4268-9428-151c382ee044',
      caption: 'first caption',
    },
  ];
  return (
    <>
      <Header />
      <Container>
        <div className='content'>
          <h2 className='text-secondary p-4 chinese'>སློབ་གྲྭ །</h2>
          {/* <div>
            <CarouselComponent item={carouselContent} />
          </div> */}
          <div className='p-4'>
            <SchoolTimeLine
              number={totalNumber}
              date={date}
              title={title}
              content={chineseContent}
            />
          </div>
        </div>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};
export default connect(mapStateToProps)(School1);
